import { z } from "zod";

// ─── Send Feedback Input ───────────────────────────────────────────────────

export const sendFeedbackInputSchema = z.object({
  subject: z.string().min(1, "Subject is required").max(200),
  message: z.string().min(1, "Message is required").max(5000),
});
export type SendFeedbackInput = z.infer<typeof sendFeedbackInputSchema>;
